export const MSK_TOPIC = 'Personal Sidekick Knowledge'
export const MSK_NAME = 'Personal Sidekick'
